import { render, staticRenderFns } from "./IF-AtısAlt.vue?vue&type=template&id=2a2db78c&scoped=true&"
import script from "./IF-AtısAlt.vue?vue&type=script&lang=js&"
export * from "./IF-AtısAlt.vue?vue&type=script&lang=js&"
import style0 from "./IF-AtısAlt.vue?vue&type=style&index=0&id=2a2db78c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2db78c",
  null
  
)

export default component.exports